import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    FormGroup
} from 'reactstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Internal_Property_By_Id,
    postAPI_Update_Property,
    putAPI_Update_Subscribed_Property_Products,
    gAPI_Subscribed_Property_Products_List_By_Id,
    gAPI_Applicable_Products_List
} from '../../../../../constants/APIs';
import Select from 'react-select';
import languages from '../../../../../data/languages';

const customProductNames = [
    "Booking Agent for website and booking engine",
    "Social Connect",
    "Email Assistant",
    "Voice Connect"
];
export default function AvailableProduct({
    propertyId,
    property,
    isSuccess,
    setIsSuccess,
    clickEnd,
    groupId,
    id,
    stepCreate,
    userName,
    getdata,
    stepStatusMap
}) {
    const [propertyLanguage, setPropertyLanguage] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [propertyData, setPropertyData] = useState({
        groupId,
        languages: ['en']
    });
    const [initialDataList, setInitialDataList] = useState([]);
    const [hasChanged, setHasChanged] = useState(false);
    const isUpdated = stepStatusMap?.availableProduct === "UpdatedOrCreated";

    useEffect(() => {
        if (propertyId) {
            const activeLangs = property?.languages || [];
            const updatedLanguages = languages.map(lang => ({
                ...lang,
                checked: activeLangs.includes(lang.code),
            }));

            setPropertyLanguage(updatedLanguages);
            setPropertyData(property);
        } else {
            setPropertyLanguage(languages.map(l => ({ ...l, checked: false })));
        }

        if (propertyId !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Subscribed_Property_Products_List_By_Id}/${propertyId}`,
            })
                .then((res) => {
                    const cleanedData = res.data.map(item => ({
                        ...item
                    }));
                    setDataList(cleanedData);
                })
                .catch((err) => console.log('err', err));
        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Applicable_Products_List}`,
            })
                .then((res) => {
                    setDataList(res.data);
                })
                .catch((err) => console.log('err', err));
        }
    }, [propertyId, groupId]);

    useEffect(() => {
        if (dataList.length > 0 && initialDataList.length === 0) {
            setInitialDataList(dataList.map(item => ({ ...item })));
        }
    }, [dataList]);
    const handleChange = (e) => {
        setPropertyData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleLanguageSelectChange = (selectedOptions) => {
        const selectedCodes = selectedOptions.map(opt => opt.value);

        setPropertyLanguage(prev =>
            prev.map(lang => ({
                ...lang,
                checked: selectedCodes.includes(lang.code),
            }))
        );

        setPropertyData(prev => ({
            ...prev,
            languages: selectedCodes,
        }));
        setHasChanged(true);
    };

    const handleCheckedChange = (e, index) => {
        setDataList(prev => {
            const updated = [...prev];
            updated[index].available = e.target.checked;
            return updated;
        });
        setHasChanged(true);
    };
    const handleSubmit = async () => {
        try {
            const applicableProducts = {
                propertyId,
                groupId,
                products: dataList.map(item => ({
                    productId: item.productId,
                    productName: item.productName,
                    available: item.available ?? false,
                })),
            };

            await AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_Subscribed_Property_Products}/${propertyId}`,
                data: applicableProducts,
            });

            await AxiosAPI({
                method: 'put',
                url: `${postAPI_Update_Property}/${propertyId}`,
                data: { ...propertyData, updater: 'admin' },
            });

            const productDetails = dataList.map((item, index) => {
                const initial = initialDataList[index];
                return {
                    productName: item.productName,
                    before: initial?.available ?? false,
                    after: item.available ?? false
                };
            });

            const payload = {
                onboardSessionId: id,
                stepName: "select-products",
                status: "UpdatedOrCreated",
                creator: userName,
                modifiedBy: "Dashboard",
                productDetails
            };

            console.log("StepCreate Payload:", payload);
            await stepCreate(payload);
            NotificationManager.success(
                '',
                'Products and language updated successfully',
                3000
            );
            setIsSuccess(true);
            setHasChanged(false);
            await getdata(id)
        } catch (error) {
            console.error('Update failed:', error);

            const errorMessage =
                error?.response?.data?.message ||
                'Something went wrong. Please try again.';

            NotificationManager.error(
                '',
                errorMessage,
                3000
            );
        }
    };

    const handleNotNow = async () => {
        await stepCreate({
            onboardSessionId: id,
            stepName: "Select-Products",
            status: "Skipped",
            creator: userName,
            modifiedBy: "Dashboard",
            productDetails: null
        });
        clickEnd();
    };

    const languageOptions = languages.map(lang => ({
        value: lang.code,
        label: `${lang.name} (${lang.code})`,
    }));

    const selectedLanguages = propertyLanguage
        .filter(lang => lang.checked)
        .map(lang => ({
            value: lang.code,
            label: `${lang.name} (${lang.code})`,
        }));

    return (
        <Fragment>
            <Row className="mt-2  mr-4">
                {/* <Colxx sm={12}>
                    <Label>Property Name</Label>
                    <Input
                        type="text"
                        value={propertyData.name || ''}
                        onChange={handleChange}
                        name="name"
                    />
                </Colxx> */}

                <Colxx sm={12} className="">
                    <h4>Applicable Products</h4>
                    <table className="table table-bordered">
                        <tbody>
                            {dataList.slice(0, 4).map((item, index) => (
                                <tr key={item.productId}>
                                    <td>{customProductNames[index] || item.productName}</td>
                                    <td className="text-center">
                                        <Input
                                            type="checkbox"
                                            checked={item.available ?? false}
                                            onChange={(e) => handleCheckedChange(e, index)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Colxx>

                <Colxx sm={8} className="mt-3">
                    <h5>Knowledge Base Languages</h5>
                    <FormGroup>
                        <Select className=' input_sty'
                            isMulti
                            options={languageOptions}
                            value={selectedLanguages}
                            onChange={handleLanguageSelectChange}
                            placeholder="Select Languages"
                        />
                    </FormGroup>
                </Colxx>

                <Colxx sm={12} className="text-right mt-4">
                    {isUpdated && !hasChanged ? (
                        <Button color="primary" outline onClick={clickEnd}>
                            Next
                        </Button>
                    ) : (
                        <div className='widget-wrap'>
                            <Button
                                color="primary"
                                size="lg"
                                outline
                                onClick={handleSubmit}
                            >
                                Update Products & Languages
                            </Button>
                            <h6
                                style={{ display: 'flex' }}
                                className="ml-4 not-now"
                                onClick={handleNotNow}
                            >
                                Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M60 25 H100 L90 15 M100 25 L90 35"
                                        fill="none"
                                        stroke="grey"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                            </h6>

                        </div>

                    )}
                </Colxx>
            </Row>
        </Fragment >
    );
}
